import { toast } from 'sonner';

export async function readResponseErrorMessage(response: Response, fallback: string): Promise<string> {
  const hasHeaders = typeof response.headers?.get === 'function';
  const contentType = hasHeaders
    ? response.headers.get('content-type')?.toLowerCase() ?? ''
    : '';
  const shouldTryJson = contentType.includes('application/json') || !hasHeaders;

  if (shouldTryJson && typeof response.json === 'function') {
    const data = await response.json().catch(() => null) as
      | { message?: unknown; title?: unknown }
      | null;

    if (typeof data?.message === 'string' && data.message.trim() !== '') {
      return data.message;
    }

    if (typeof data?.title === 'string' && data.title.trim() !== '') {
      return data.title;
    }
  }

  if (typeof response.text !== 'function') {
    return fallback;
  }

  const text = await response.text().catch(() => '');
  return text.trim() || fallback;
}

export function getErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error && error.message.trim() !== '') {
    return error.message;
  }

  if (typeof error === 'string' && error.trim() !== '') {
    return error;
  }

  return fallback;
}

export function showGlobalError(message: string, title?: string) {
  if (!title || title.trim() === '' || title === message) {
    toast.error(message);
    return;
  }

  toast.error(title, {
    description: message,
  });
}